import PostsScreen from './components/PostsScreen'

export default {
  path: '/noticias',
  name: 'Posts',
  component: PostsScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Posts/index.js